import { ApolloProvider } from 'core/net/ApolloProvider';
import { ISensorGroup } from 'app/business-logic/domain-models/ISensorGroup';
import { FETCH_SENSOR_GROUPS } from './graphql/facility.fetchSensorGroups';
import { FetchSensorGroupsQuery, FetchSensorGroupsQueryVariables } from 'app/__generated__/global';
import { convertMeasurementGroupToSensorGroup } from './helpers/convertMeasurementGroupToSensorGroup';

export async function fetchSensorGroups(): Promise<ISensorGroup[]> {
  const { data } = await ApolloProvider.global().query<FetchSensorGroupsQuery, FetchSensorGroupsQueryVariables>({
    query: FETCH_SENSOR_GROUPS,
    fetchPolicy: 'no-cache',
  });
  return (
    data?.facility?.measurementGroups
      ?.flatMap(({ defaultOrder, id, description }) => {
        if (typeof defaultOrder !== 'number') return [];
        return {
          defaultOrder,
          id,
          description: description ?? '',
          sourceAreaProcessGroupIds: [],
        };
      })
      .map(measurementGroup => convertMeasurementGroupToSensorGroup(measurementGroup))
      .sort((left, right) => left.defaultOrder - right.defaultOrder) ?? []
  );
}
